import * as marietta from '../../../..';
import { optWizardMode } from '../../../../view3d/webcad/util/Option3DInterface';
import { ITEM_MODE_NO } from '../../../Constants';
import { Mode3DTool } from '../../../../view3d/webcad/util/Mode3DTool';

/**
 * 部屋・建具指定ウィザードの管理クラス
 */
export class WizardManager {
  // ダイアログ管理用配列
  public wizardStepCollection: Function[] = [];

  // wizardのstep
  public wizardStep: number = 0;

  constructor() {
    this.step();
  }

  private step = () => {
    // ウィザードの開始
    this.wizardStepCollection.push(() => {
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.WizardStartDialog);
    });
    // step1
    this.wizardStepCollection.push(() => {
      // 左メニューを閉じる
      document.getElementById('checkSelectMode')
        .dispatchEvent(new MouseEvent('click'));

      // 部屋指定ウィザード
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.WizardRoomTypeSelection, true);
    });
    // step2
    this.wizardStepCollection.push(() => {
      // ピンとアイテムの紐づけウィザードの開始
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.WizardStartPinDialog, true);
    });
    // step3
    this.wizardStepCollection.push(() => {
      // ピンとアイテムの紐づけウィザード
      const mode3d = new Mode3DTool();
      const opt: optWizardMode = { isWizardMode: true };
      mode3d.setOption(opt);
      mode3d.start();
    });
  };

  public start = () => {
    this.wizardStep = 0;
    this.wizardStepCollection[this.wizardStep]();
  };

  public next = (count: number) => {
    if (this.wizardStepCollection.length <= this.wizardStep) this.end();
    this.wizardStep += count;
    this.wizardStepCollection[this.wizardStep]();
  };

  public end = () => {
    this.wizardStep = 0;
    // アクションモードの設定
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updatecurrentActionModeFromItemMenu();
  };

  /**
   * ウィザードで使用されるアイテムが存在しているか
   */
  public hasWizardItem(): boolean {
    return this.getTargetRoom().length > 0;
  }

  /**
   * 部屋リスト取得
   */
  public getTargetRoom(): marietta.webcad.item.Room[] {
    let itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO) as marietta.webcad.item.Room[];
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO) as marietta.webcad.item.Room[]);
    itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO) as marietta.webcad.item.Room[]);
    return itemList;
  }

  /**
   * 建具リスト取得 今は使用されていない
   */
  public getTargetFitting(): marietta.webcad.item.Fitting[] {
    const itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTING_NO) as marietta.webcad.item.Fitting[];
    // fit01_01 壁は対象外とする
    return itemList.filter((fitting: marietta.webcad.item.Fitting) => fitting.itemInfo.id !== 'fit01_01');
  }

  /**
   * カメラピンリスト取得
   */
  public getTargetPin(): marietta.webcad.item.PinPicture[] {
    return marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FREETEXT_NO)
      .filter((pin) => pin.itemInfo.id === 'txt03_01') as marietta.webcad.item.PinPicture[];
  }
}
